import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=4f004014&scoped=true"
import script from "./ProductProperty.vue?vue&type=script&lang=js"
export * from "./ProductProperty.vue?vue&type=script&lang=js"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=4f004014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f004014",
  null
  
)

export default component.exports